import { isNil } from 'lodash';
import { DynamicMenu } from 'models/workflows/workflows.types';

import CONST from 'utils/constants';

const { MENU_APP_SOURCES } = CONST;

const WORK_REGEX = /^\/(work-public|work|flow)\/([^/]+)/;

export const getMakertplaceKey = (pathname: string) => {
  const match = new RegExp(WORK_REGEX).exec(pathname);
  if (match) {
    return match[2]; // captured key after "work-public" | "work" | "flow"
  }
  return '';
}

export const getFirstMenuItemUrl = (menu: DynamicMenu | null) => {
  if (!isNil(menu) && menu.length > 0) {
    const { appSource, marketplaceKey } = menu[0];

    if (appSource === MENU_APP_SOURCES.WORKFLOW) {
      return `/work/${marketplaceKey}`;
    }
    if (appSource === MENU_APP_SOURCES.CUSTOM_FLOW) {
      return `/flow/${marketplaceKey}`;
    }
  }
  return '/no-apps-installed';
}

export const getRouteKey = () => {
  return `route-${getMakertplaceKey(window.location.pathname)}`;
}